(function () {
  'use strict';

  const ROWS_HOLDER = '[data-timeline-rows]';
  const ROW = '[data-timeline-row]';
  const ROW_EDITOR = '[data-timeline-row-editor]';
  const BUTTON = '[data-timeline-button]';
  const BLOCK_SCROLL = '[data-block-scroll]';
  const SELECTED_CLASS = 'is-selected';

  if (customElements.get('timeline-component')) {
    return;
  }

  class TimelineComponent extends HTMLElement {
    constructor() {
      super();

      this.rows = this.querySelectorAll(ROW);

      if (this.rows.length < 2) {
        return;
      }

      this.rowsWidth = 0;
      this.rowsHeight = [];

      this.holderTop = 0;
      this.holderHeight = 0;

      this.buttons = this.querySelectorAll(BUTTON);
      this.rowsHolder = this.querySelector(ROWS_HOLDER);

      this.requestAnimation = null;

      this.isDesktopView = !this.isMobile();
      this.isScrollEnabled = false;

      this.scrollEvent = (event) => {
        this.scrollEvents(event);
      };

      this.nativeScrollEvent = () => {
        this.scrollEvents();
      };

      this.resizeEvent = () => {
        this.resizeEvents();
      };
    }


    isMobile() {
      if (
        window.theme &&
        typeof window.theme.isMobile !== 'undefined'
      ) {
        return window.theme.isMobile;
      }

      return window.matchMedia(
        '(max-width: 749px)'
      ).matches;
    }


    connectedCallback() {
      if (!this.rows || this.rows.length < 2) {
        return;
      }

      this.updateHolderDimensions();
      this.calculateRowsDimensions();

      this.requestAnimation = requestAnimationFrame(() => {
        this.updateHolderDimensions();
        this.calculateRowsDimensions();
        this.calculatePosition();
      });


      /*
       * Keep Broadcast's original custom scroll event.
       */
      if (this.isDesktopView && !this.isScrollEnabled) {
        this.enableDesktopScroll();
      }


      /*
       * Mobile horizontal Timeline listener.
       * Your custom CSS currently hides this original
       * Timeline on mobile, so it won't interfere with
       * the vertical mobile version.
       */
      if (this.rowsHolder) {
        this.rowsHolder.addEventListener(
          'scroll',
          this.scrollEvent,
          { passive: true }
        );
      }


      document.addEventListener(
        'theme:resize:width',
        this.resizeEvent
      );


      /*
       * Timeline dot buttons
       */
      if (this.buttons.length) {
        this.buttons.forEach((button, index) => {

          button.addEventListener('click', (event) => {
            event.preventDefault();

            const row =
              event.currentTarget.closest(ROW);

            if (!row) {
              return;
            }


            /*
             * MOBILE
             */
            if (this.isMobile()) {

              if (!this.rowsHolder) {
                return;
              }

              const offset = 16;

              const left =
                row.offsetLeft - offset;

              this.rowsHolder.scrollTo({
                left: left,
                behavior: 'smooth'
              });

              return;
            }


            /*
             * DESKTOP
             */
            this.updateHolderDimensions();

            const tallestRow =
              Math.max(...this.rowsHeight);

            const sectionPerRow =
              this.holderHeight /
              this.rows.length;

            const sectionTop =
              this.getBoundingClientRect().top +
              window.scrollY;

            let scrollPosition;


            if (
              index > 0 &&
              tallestRow < sectionPerRow
            ) {
              scrollPosition =
                sectionTop +
                sectionPerRow * index +
                1;
            } else {
              scrollPosition =
                sectionTop + 1;
            }


            if (
              window.theme &&
              typeof window.theme.scrollTo ===
                'function'
            ) {

              window.theme.scrollTo(
                scrollPosition
              );

            } else {

              window.scrollTo({
                top: scrollPosition,
                behavior: 'smooth'
              });

            }

          });

        });
      }
    }


    enableDesktopScroll() {
      this.isScrollEnabled = true;

      /*
       * Original Broadcast event.
       */
      document.addEventListener(
        'theme:scroll',
        this.scrollEvent
      );

      /*
       * IMPORTANT FIX:
       * Native browser scroll fallback.
       */
      window.addEventListener(
        'scroll',
        this.nativeScrollEvent,
        { passive: true }
      );
    }


    disableDesktopScroll() {
      this.isScrollEnabled = false;

      document.removeEventListener(
        'theme:scroll',
        this.scrollEvent
      );

      window.removeEventListener(
        'scroll',
        this.nativeScrollEvent
      );
    }


    updateHolderDimensions() {
      this.holderTop =
        this.getBoundingClientRect().top +
        window.scrollY;

      this.holderHeight =
        this.offsetHeight;
    }


    resizeEvents() {
      this.updateHolderDimensions();

      this.calculateRowsDimensions();

      this.requestAnimation =
        requestAnimationFrame(() => {

          this.updateHolderDimensions();

          this.calculatePosition();

        });


      const desktop =
        !this.isMobile();


      if (
        desktop &&
        !this.isScrollEnabled
      ) {

        this.enableDesktopScroll();

      } else if (
        !desktop &&
        this.isScrollEnabled
      ) {

        this.disableDesktopScroll();

      }


      this.isDesktopView = desktop;
    }


    scrollEvents(event = null) {

      if (this.requestAnimation) {
        return;
      }


      const source =
        event &&
        event.currentTarget
          ? event.currentTarget
          : null;


      this.requestAnimation =
        requestAnimationFrame(() => {

          this.calculatePosition(source);

        });

    }


    removeAnimationFrame() {

      if (!this.requestAnimation) {
        return;
      }

      cancelAnimationFrame(
        this.requestAnimation
      );

      this.requestAnimation = null;
    }


    calculateRowsDimensions() {

      if (!this.rows.length) {
        return;
      }


      this.rowsHeight = [];
      this.rowsWidth = 0;

      let accumulatedHeight = 0;


      this.rows.forEach((row, index) => {

        this.rowsHeight.push(
          row.offsetHeight
        );


        const styles =
          getComputedStyle(row);


        const marginRight =
          parseFloat(
            styles.marginRight
          ) || 0;


        this.rowsWidth +=
          row.offsetWidth +
          marginRight;


        /*
         * Shopify Theme Editor
         */
        if (window.Shopify?.designMode) {

          const editorRows =
            this.querySelectorAll(
              ROW_EDITOR
            );


          if (editorRows.length) {

            accumulatedHeight +=
              row.offsetHeight;


            if (editorRows[index]) {

              editorRows[
                index
              ].style.setProperty(
                '--row-height-min',
                `${row.offsetHeight}px`
              );

            }


            if (editorRows[index + 1]) {

              editorRows[
                index + 1
              ].style.setProperty(
                '--row-top-mobile',
                `${accumulatedHeight}px`
              );

            }

          }
        }

      });

    }


    calculatePosition(source = null) {

      this.removeAnimationFrame();

      this.updateHolderDimensions();


      const desktop =
        !this.isMobile();


      const sectionPerRow =
        this.holderHeight /
        this.rows.length;


      let currentSection =
        this.holderTop;


      const viewportHeight =
        window.innerHeight;


      /*
       * Same activation point used by
       * the original Broadcast Timeline.
       */
      const scrollTrigger =
        window.scrollY +
        1.5 * viewportHeight;


      let mobilePercent = 0;



      /*
       * MOBILE HORIZONTAL PROGRESS
       */
      if (
        !desktop &&
        source &&
        this.rowsHolder
      ) {

        const scrollLeft =
          this.rowsHolder.scrollLeft -
          16;


        const availableWidth =
          this.rowsWidth -
          this.rowsHolder.offsetWidth;


        if (availableWidth > 0) {

          mobilePercent =
            (scrollLeft /
              availableWidth) *
            100;

        }


        this.style.setProperty(
          '--percent-mobile',
          `${mobilePercent}%`
        );
      }



      /*
       * If desktop Timeline is nowhere
       * near viewport, don't do unnecessary
       * calculations.
       */
      if (
        desktop &&
        (
          scrollTrigger <
            this.holderTop ||

          scrollTrigger >
            this.holderTop +
            this.holderHeight +
            viewportHeight
        )
      ) {

        return;
      }



      /*
       * ACTIVATE TIMELINE ROWS
       */
      this.rows.forEach(
        (row, index) => {

          if (index > 0) {

            let selected;


            /*
             * MOBILE
             */
            if (!desktop) {

              const rowPercent =
                (
                  row.offsetLeft /
                  this.rowsWidth
                ) * 100;


              selected =
                mobilePercent >
                rowPercent;

            }


            /*
             * DESKTOP
             */
            if (desktop) {

              selected =
                currentSection +
                  sectionPerRow <
                scrollTrigger;


              /*
               * Animate the vertical
               * timeline progress line.
               */
              if (
                currentSection -
                  sectionPerRow <
                scrollTrigger
              ) {

                const previousRow =
                  row.previousElementSibling;


                if (previousRow) {

                  let percent =
                    (
                      (
                        scrollTrigger -
                        currentSection
                      ) /
                      sectionPerRow
                    ) * 100;


                  percent =
                    Math.max(
                      0,
                      Math.min(
                        100,
                        percent
                      )
                    );


                  previousRow.style.setProperty(
                    '--percent-desktop',
                    `${percent}%`
                  );

                }

              }

            }


            row.classList.toggle(
              SELECTED_CLASS,
              selected
            );

          }


          currentSection +=
            sectionPerRow;

        }
      );
    }


    disconnectedCallback() {

      if (this.isScrollEnabled) {
        this.disableDesktopScroll();
      }


      if (this.rowsHolder) {

        this.rowsHolder.removeEventListener(
          'scroll',
          this.scrollEvent
        );

      }


      document.removeEventListener(
        'theme:resize:width',
        this.resizeEvent
      );


      this.removeAnimationFrame();
    }


    onBlockSelect(event) {

      const blockScroll =
        this.querySelector(
          BLOCK_SCROLL
        );


      if (!blockScroll) {
        return;
      }


      const selectedBlock =
        event.srcElement;


      const index =
        [
          ...selectedBlock
            .parentElement
            .children
        ].indexOf(
          selectedBlock
        );


      const row =
        this.rows[index];


      if (!row) {
        return;
      }


      blockScroll.scrollTo({
        top: 0,
        left: row.offsetLeft,
        behavior: 'smooth'
      });
    }
  }


  customElements.define(
    'timeline-component',
    TimelineComponent
  );

})();